import { render, staticRenderFns } from "./orderNav.vue?vue&type=template&id=15d9922f&scoped=true"
import script from "./orderNav.vue?vue&type=script&lang=js"
export * from "./orderNav.vue?vue&type=script&lang=js"
import style0 from "./orderNav.vue?vue&type=style&index=0&id=15d9922f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9922f",
  null
  
)

export default component.exports